// Import Actions
import { SET_SHIPPING_FEES, REMOVE_SHIPPING_FEE } from './ShippingFeeActions';
import { LOGOUT_USER } from '../User/UserActions';

// Initial State
export const initialState = {
    data: [],
};

const ShippingFeeReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_SHIPPING_FEES: {
            const otherShippingFees = state.data.filter(shippingFee => !action.shippingFees.find(shippingFeeToSet => shippingFeeToSet._id === shippingFee._id));
            return {
                ...state,
                data: otherShippingFees.concat(action.shippingFees),
            };
        }

        case REMOVE_SHIPPING_FEE: {
            return {
                ...state,
                data: state.data.filter(shippingFee => shippingFee._id !== action.id),
            };
        }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default ShippingFeeReducer;
